<template>
  <v-row>
    <v-col cols="7" class="">
      <div class="d-flex">
        <div class="sigfloH1 mb-1 mr-4 black--text">
          {{ configurator.currentSubsystemStepComponent ? configurator.currentSubsystemStepComponent.name : '' }}
        </div>
        <sig-help-dialog-button logo-side="left" :title="sigTitle" :message="sigMessage" />
      </div>
      <span class="textMuted sigfloBodySmall" v-show="!hasProducts">
        {{ configurator.currentSubsystemStepComponent ? configurator.currentSubsystemStepComponent.description : '' }}
      </span>
    </v-col>
    <v-col class="text-right d-flex" v-if="hasProducts">
      <v-spacer />
      <v-btn
        class="text-capitalize textEmphasis mr-2 sigfloButtonSmall600"
        text
        rounded
        @click="saveSubsystemStepProgress('subsystem')"
        >Save Progress</v-btn
      >
      <v-btn rounded color="#E1D4F7" class="text-capitalize elevation-0 sigfloButton px-6"
        ><v-icon>mdi-cart-outline</v-icon>Total: ${{ sellPrice }}</v-btn
      >
    </v-col>
  </v-row>
</template>

<script>
  import { mapState } from 'vuex';
  import sigHelpDialogButton from '@/components/shared/SigHelpDialogButton';
  export default {
    components: {
      sigHelpDialogButton
    },
    data() {
      return {};
    },
    computed: {
      ...mapState(['configurator']),
      sellPrice() {
        return this.configurator.currentSubsystem ? this.formatPrice(this.configurator.currentSubsystem.sellPrice) : '';
      },
      /**
       * Returns the title of the signal message model.
       * If the current subsystem step component does not have a signal message model, an empty string is returned.
       * Otherwise, the message title of the signal message model is returned.
       *
       * @returns {string} The title of the signal message model.
       */
      sigTitle() {
        if (!this.configurator.currentSubsystemStepComponent.sigMessageModel) {
          return '';
        }

        return this.configurator.currentSubsystemStepComponent.sigMessageModel.messageTitle;
      },
      /**
       * Returns the signature message for the current subsystem step component.
       * If the sigMessageModel is not available, an empty string is returned.
       * @returns {string} The signature message.
       */
      sigMessage() {
        if (!this.configurator.currentSubsystemStepComponent.sigMessageModel) {
          return '';
        }
        return this.configurator.currentSubsystemStepComponent.sigMessageModel.message;
      }
    }
  };
</script>
